import React from 'react';
import { PropTypes } from 'prop-types';
import Currency from 'components/Currency';
import RoomSelectButton from './RoomSelectButton';
import SummaryPopover from './SummaryPopover';

const propTypes = {
  room: PropTypes.object,
  subTotal: PropTypes.number,
  originalSubtotal: PropTypes.number,
  rewards: PropTypes.array,
  onSelect: PropTypes.func,
  index: PropTypes.number,
  isWaitListBooking: PropTypes.bool,
  waitlistComp: PropTypes.bool,
  nightlyAverage: PropTypes.number,
  originalNightlyAverage: PropTypes.number
};

function RoomListItemActions({
  room,
  rewards,
  waitlistComp,
  originalNightlyAverage,
  nightlyAverage,
  index,
  originalSubtotal,
  subTotal,
  onSelect,
  isWaitListBooking
}) {
  return (
    <>
      <p>Nightly Avg.</p>
      <h3>
        {room.minRoomRate.eligibleForComp &&
        (rewards?.length > 0 || waitlistComp) ? (
          <span>COMP</span>
        ) : (
          <React.Fragment>
            {originalNightlyAverage && (
              <del>
                <Currency
                  value={originalNightlyAverage}
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                />
              </del>
            )}
            <Currency
              value={nightlyAverage}
              minimumFractionDigits={0}
              maximumFractionDigits={0}
            />
          </React.Fragment>
        )}
      </h3>
      <SummaryPopover
        index={index}
        room={room}
        nightlyAverage={nightlyAverage}
        originalSubtotal={originalSubtotal}
        subTotal={subTotal}
      />
      <RoomSelectButton
        onClick={onSelect}
        room={room}
        isWaitListBooking={isWaitListBooking}
      />
    </>
  );
}

RoomListItemActions.propTypes = propTypes;

export default RoomListItemActions;
